import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type { TPostErrorReport } from "./error-report.types";

export const postErrorReport = {
  url: () => `/exam/reportBug`,
  fn: async (request: TPostErrorReport["request"]) => {
    const { data } = await gwtClient<TPostErrorReport["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      // parameter to set for changing content type to default
      fetchOptions: {
        isJson: true
      },
      url: postErrorReport.url(),
      data: request.body
    });
    return data;
  },
  key: (request: TPostErrorReport["request"]) => {
    return reject(
      [postErrorReport.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: TPostErrorReport["queryOptions"]) => ({
    ...options.queryOptions,
    queryKey: postErrorReport.key(options.request),
    queryFn: () => postErrorReport.fn(options.request)
  }),
  useQuery: (options: TPostErrorReport["queryOptions"]) =>
    useQuery(postErrorReport.query(options)),
  useMutation: (options?: TPostErrorReport["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: postErrorReport.fn
    })
};
